<template>
  <div class="wrapper">
    <ul class="current_user">
      <li>姓名：{{ selectdata.patientname }}</li>
      <li>就诊ID号：<span>{{ selectdata.patientId }}</span></li>
      <!-- <li>身份证：<span>{{ selectdata.idcardno.replace(/(\w{4})\w*(\w{4})/, "$1******$2") }}</span></li> -->
      <span @click="showNation = true" class="switch">切换就诊人</span>
      <img src="@/assets/record/jkm2.png" @click.stop="cardbtn(selectdata)"/>
    </ul>
    <van-tabs v-model="active" title-active-color="#3C9ECF" swipeable @click="getRegList(active)">
      <van-tab title="待支付">
        <div v-if="payShow">
          <ul class="pay_list" v-for="item in payList" :key="item.orderId" @click="tz(item)">
            <li>预约院区：<span>{{ item.hspCode == 31?"计星院区":(item.hspCode == 41 || item.hspCode == 42)?"迎宾院区":"金塘院区" }}</span></li>
            <li>预约科室：<span>{{ item.deptName }}</span></li>
            <li>医生姓名：<span>{{ item.doctorName }}</span></li>
            <li>预约日期：<span>{{ item.orderDate }}</span></li>
            <li>挂号费用：<span>{{ item.fee }} 元</span></li>
            <!-- <img src="@/assets/appointment/xsj_r.png"> -->
            <li class="btns">
              <span class="qxyy" @click.stop="cancle(item.orderId, active)">取消预约</span>
              <span class="zf" @click.stop="push(item)">支付</span>
            </li>
          </ul>
        </div>
        <van-empty v-if="!payShow"
          class="custom-image"
          image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
          description="暂无记录"
        />
      </van-tab>
      <van-tab title="已支付">
        <div v-if="paidShow">
          <ul class="pay_list" v-for="item in paidList" :key="item.orderId" @click="tz(item)">
            <li>预约院区：<span>{{ item.hspCode == 31?"计星院区":(item.hspCode == 41 || item.hspCode == 42)?"迎宾院区":"金塘院区" }}</span></li>
            <li>预约科室：<span>{{ item.deptName }}</span></li>
            <li>医生姓名：<span>{{ item.doctorName }}</span></li>
            <li>预约日期：<span>{{ item.orderDate }}</span></li>
            <li>挂号费用：<span>{{ item.fee }} 元</span></li>
            <li class="btns">
              <span class="qxyy" v-if="item.isexpired != 1" @click.stop="cancle(item.orderId, active)">取消预约</span>
            </li>
          </ul>
        </div>
        <van-empty v-if="!paidShow"
          class="custom-image"
          image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
          description="暂无记录"
        />
      </van-tab>
    </van-tabs>
    <van-popup v-model="showNation" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirmNation"
        @cancel="showNation = false"
      />
    </van-popup>
    <judgment></judgment>
  </div>
</template>

<script>
import { selectVisitinfos, getRegRecord, CancelLockRegOrder } from "@/request/api.js";
import Judgment from "@/components/Judgment/Judgment.vue";
export default {
  components: {
    Judgment
  },
  data() {
    return {
      nowDay: new Date(this.$moment().format("YYYY-MM-DD")),
      active: 0,
      showNation: false,
      columns: [],
      selectdata: {
        idcardno: ""
      },
      payShow: false,
      paidShow: false,
      payList: [],
      paidList: []
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if(from.path == "/hospitalRegister" || from.path == "/index" || from.path == "/AppointmentDetails" || from.path == "/"){
        vm.getVisitinfos();
      } else {
      }
    })
  },
  created() {
    
  },
  mounted() {
    // this.getVisitinfos();
  },
  methods: {
    // 获取所有就诊人
    async getVisitinfos() {
      let openid = sessionStorage.getItem("openid");
      let res = await selectVisitinfos({ openid });
      this.columns = res.data.obj;
      res.data.obj.forEach(item => {
        item.text = item.patientname;
        if (item.style == 1) {
          this.selectdata = item;
        }
      });
      this.getRegList(0);
    },
    // 切换就诊卡
    onConfirmNation(value) {
      this.selectdata = value;
      this.showNation = false;
      this.getRegList(this.active);
      this.Toast("切换成功");
    },
    // 查看电子卡
    cardbtn(item){
      sessionStorage.setItem("card", JSON.stringify(item));
      this.$router.push("/HealthCard");
    },
    tz(item){
      // this.$router.push(`/RegRecordDetail?lockid=${item.orderId}`)
      sessionStorage.setItem("orderUser", JSON.stringify(this.selectdata));
      sessionStorage.setItem("orderDetails", JSON.stringify(item));
      this.$router.push(`/RegRecordDetail`)
    },
    // 获取待支付
    async getRegList(data){
      this.active = data;
      this.payList = [];
      this.paidList = [];
      if(data == 0){
        let map = {
          isPay: "0",
          patientId: this.selectdata.patientId,
          userId: "7148"
        }
        let res = await getRegRecord(map);
        if(res.data.message == "操作成功" && res.data.obj.resultData.length != 0){
          this.payList = res.data.obj.resultData
          this.payShow = true
        } else {
          // this.active = 1
          // this.getRegList(1)
          this.payShow = false
        }
      } else if(data == 1){
        let map = {
          isPay: "1",
          patientId: this.selectdata.patientId,
          userId: "7148"
        }
        let res = await getRegRecord(map);
        if(res.data.message == "操作成功" && res.data.obj.resultData.length != 0){
          this.paidList = res.data.obj.resultData
          this.paidShow = true
        } else {
          // this.active = 0
          this.paidShow = false
        }
      }
    },
    // 取消预约
    cancle(id, data){
      this.Dialog.confirm({
        title: '提示',
        message: '确定取消预约？',
        confirmButtonColor: "#ee0a24"
      })
        .then(async () => {
          let map = {
            lockID: id,
            userId: "7148"
          }
          let res = await CancelLockRegOrder(map)
          if(res.data.message == '操作成功'){
            this.getRegList(data)
            this.Toast.success("取消成功")
          } else {
            this.Toast(res.data.message)
          }
        })
        .catch(() => {});
    },
    push(item){
      sessionStorage.setItem("orderId",item.orderId)
      this.$router.push("/countDown")
    },
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  background: #f8f8f8;
  overflow: auto;
  /deep/ .van-tabs {
    border-top: 1px solid #f9f9f9;
    border-bottom: 1px solid #f9f9f9;
    .van-tab__text--ellipsis {
      letter-spacing: 1px;
      font-size: 16px;
      font-weight: 600;
    }
    .van-tabs__line {
      background-color: #3c9ecf !important;
    }
  }
  .pay_list{
    position: relative;
    margin: 10px 10px 0px 10px;
    padding: 10px;
    border-radius: 6px;
    background: #fff;
    font-size: 16px;
    color: #999;
    letter-spacing: 1px;
    >li{
      margin-top: 4px;
      >span{
        letter-spacing: 0px;
        color: black;
      }
    }
    >li:nth-child(1){
      margin-top: 0px;
    }
    >img{
      position: absolute;
      top: 20px;
      right: 30px;
    }
    .btns{
      text-align: right;
      display: flex;
      justify-content: flex-end;
      >span{
        font-size: 13px;
        letter-spacing: 1px;
        border: 1px solid #999;
        padding: 4px 10px;
        border-radius: 16px;
        font-weight: bold;
      }
      .qxyy{
        margin-right: 10px;
        color: rgba(203, 52, 52, 0.6);
        border-color: rgba(203, 52, 52, 0.6);
      }
      .zf{
        color: #df6800;
        border-color: #df6800;
      }
    }
  }
  .current_user{
    position: relative;
    margin: 4px 4px 2px 4px;
    padding: 10px;
    background: #E6F5FC;
    border-radius: 6px;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 1px;
    >li{
      >span{
        letter-spacing: 0px;
      }
    }
    >li:nth-child(2){
      margin: 10px 0px;
    }
    .switch{
      position: absolute;
      top: 10px;
      right: 20px;
      color: #6098ff;
    }
    >img{
      position: absolute;
      width: 40px;
      right: 46px;
      bottom: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/mySubscribe.vue